/* eslint-disable no-param-reassign */
import React, { useMemo } from 'react';
import clsx from 'clsx';

import brokenImage from '../../images/broken.svg';

import * as styles from './styles.module.css';
import helper from './helper';

const Image = ({
  className,
  imageStyleName,
  images,
  id,
  url,
  alt,
  style = {},
  transform,
  position,
  opacity,
  size,
  sizes,
  dataIndex,
  onClick,
  containerProps,
}) => {
  const imageId = useMemo(
    () =>
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 12),
    [],
  );

  // TODO: finish preloading implementation
  /*
  useEffect(() => {
    if (typeof IntersectionObserver !== 'undefined') {

      const preloadImage = (element) => {
        if (element.dataset && element.dataset.imgsrc) element.src = element.dataset.imgsrc;
        if (element.dataset && element.dataset.srcset) element.srcset = element.dataset.srcset;

        if (element.className) {
          // element.className = ` ${styles.noBlurImage} ${styles[props.imageClass]}`;
          element.className = styles[imageClass];
        }
      };

      const config = {
        rootMargin: '50px 0px',
        threshold: 0,
      };

      const imageObserver = new IntersectionObserver(function (entries, self) {
        entries.forEach((entry) => {
          let intersected = false;

          if (entry.isIntersecting) {
            intersected = true;
            preloadImage(entry.target);
          }

          if (intersected) {
            // using disconnect to destroy the intersectionObserver, which is only for one image
            self.disconnect();
          }
        });
      }, config);

      const img = document.getElementById(imageId);
      if (img) imageObserver.observe(img);
    }
  }, [imageClass, imageId]);
  */

  let image = helper.getImageById(id, images);
  let frmt = 'sm';

  if (!image && !id && url) {
    image = {
      path: url,
      alt: alt || 'static',
    };
    frmt = '';
  }

  const imgStyle = {
    ...{ transform: transform ? `rotate(${transform.rotation || 0}deg)` : undefined },
    objectPosition:
      image && !!image.focusX && !!image.focusY ? `${image.focusX * 100}% ${image.focusY * 100}%` : position,
    objectFit: size,
    opacity,
  };

  let newImage = image;
  if (image?.extensions) {
    const idx = image.extensions.findIndex((i) => i !== '.avif');
    if (idx !== -1) newImage = { ...image, path: `${image.path}${image.extensions[idx]}` };
  }

  const srcSet = helper.getSrcSet(newImage);

  if (newImage?.sizes?.includes('og')) frmt = 'og';
  else if (frmt) {
    frmt = newImage?.sizes?.includes('me') ? 'me' : 'sm';
    if (newImage?.sizes && !newImage.sizes.includes(frmt) && newImage.sizes.length > 0) [frmt] = newImage.sizes;

    // Check if browser supports src and sizes W
    if (typeof document !== 'undefined' && document) {
      const img = document.createElement('img');

      if ('sizes' in img) {
        frmt = newImage?.sizes?.includes('th') ? 'th' : 'sm';
        // sizes and srcset is supported so use the lowest quality here for blur
      }
    }
  }

  let path = null;
  if (newImage?.path) path = newImage.path;

  const imgsrc = helper.getImgSrc(path, frmt);
  const lastSlash = imgsrc.lastIndexOf('/');

  // let className = styles.blurImage;  // TODO disabled

  // random alt if not set for better SEO. Actual alt text would be much better though.
  const resolvedAlt =
    newImage?.meta?.imgTitle || newImage?.meta?.imgDesc
      ? newImage?.meta?.imgTitle || newImage?.meta?.imgDesc
      : alt || imgsrc.substring(lastSlash + 1);

  const img = (
    <img
      draggable="false"
      loading="eager"
      src={imgsrc || brokenImage}
      srcSet={srcSet}
      sizes={srcSet && srcSet.length > 0 ? sizes || '100vw' : undefined}
      alt={resolvedAlt}
      className={clsx(className, styles[imageStyleName])}
      data-imageid={id}
      data-imgsrc={imgsrc}
      data-index={dataIndex}
      id={imageId}
      style={{ ...style, ...imgStyle }}
    />
  );

  let source;
  if (image?.extensions && image.extensions.length > 1) {
    const sourceImage = { ...image, path: `${image.path}.avif` };
    const sourceSet = helper.getSrcSet(sourceImage);

    source = (
      <source
        srcSet={sourceSet}
        sizes={sourceSet && sourceSet.length > 0 ? sizes || '100vw' : undefined}
        type="image/avif"
      />
    );
  }

  return (
    <picture
      draggable="false"
      className={clsx(className, styles[imageStyleName])}
      onClick={onClick}
      data-imageid={id}
      data-imgsrc={imgsrc}
      data-index={dataIndex}
      id={imageId}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...containerProps}
    >
      {source}
      {img}
    </picture>
  );
};

export default Image;
